import Modal from "./Modal_Components/Modal";
import { useLoading, Rings } from "@agney/react-loading";
import { Xwrapper } from "react-xarrows";
import { v1 as uuidv1 } from "uuid";
import { get_workflow_data, post_step, edit_step } from "./Api";
import React, { useEffect, useState, useReducer } from "react";
import { useDispatch, useSelector } from "react-redux";
import FadeIn from "react-fade-in";
import Link from "./Link";
import Trigger_Node from "./Trigger_Node";
import Action_Node from "./Action_Node";
import Drop_Trigger_Node from "./Drop_trigger";
import Drop_Action_Node from "./Drop_action";
import Conditional_node from "./Conditional_node";
import Workflow from "./Workflow_graph";
import { getPermissions } from 'api/UsersApi'

import "bootstrap/dist/css/bootstrap.css";

export function Content() {
  const { containerProps, indicatorEl } = useLoading({
    loading: true,
    indicator: <Rings width="100" />,
  });

  return <section {...containerProps}>{indicatorEl}</section>;
}

const Playground = (props, { zoomIn, zoomOut, resetTransform, ...rest }) => {
  const [steps, setsteps] = useState([]);
  const [trigger_nodes, settriggernodes] = useState([]);
  const [action_nodes, setactionnodes] = useState([]);
  const [show, setshow] = useState(false);
  const [last_action, setlastaction] = useState([]);
  const [last_action_metadata, setlastactionmetadta] = useState([]);
  const [first_action, setfirstaction] = useState([]);
  const [workflow_graph, setworkflow] = useState({});
  const [action_modal, setactionmodal] = useState(false);
  const [show_modal_loader, setshowmodalloader] = useState(false);
  const [metadata_id, setactionmetadataid] = useState("");
  const [error, seterror] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0);
  const [workflow_id, setworkflowid] = useState("");
  const [modalkey, setmodalkey] = useState(uuidv1());
  const [queue, setqueue] = useState([]);
  const [visited, setvisited] = useState([]);
  const [sourcenode_id, setsourcenode] = useState("");
  const [conditional_flag, setconditionalflag] = useState(false);
  const [conditional_path, setpath] = useState("yes");
  const [trigger_data, settriggerdata] = useState("");
  const [category, setcategory] = useState(null);
  const [isediting, setisediting] = useState(false);
  const [variables, setvariables] = useState([]);
  const [conditions, setconditions] = useState([]);
  const [totalTriggerNode, settotalTriggerNode] = useState(0);
  const [step_id, setstepid] = useState("");
  const [permissionData, setPermissionData] = useState({});
  const wokflowData = useSelector((state) => state.workflowSetter);
  const dispatch = useDispatch();
  var workflow = new Workflow();

  useEffect(() => {

    //Getting all the steps from the server
    setShowLoader(true);
    get_workflow_data(wokflowData.workflowId)
      .then((data) => {
        handlestepsResponse(data);
      })
      .catch((err) => { });
    getPermissions().then(res => {

      setPermissionData(res)
    })
  }, [ignored]);

  //Handling the steps from the server
  function handlestepsResponse(data) {
    var triggers_data = []; //
    var actions_data = []; //
    var first_action_data = []; //
    var last_action_data = []; //
    var root = { name: "Root" };
    workflow.addNode(root, []);
    //Getting all the steps from the server
    data.steps.forEach((step) => {
      if (step.sources.length == 0) {
        triggers_data.push(step);

        workflow.addNode(step, [root]);

        data.steps.find((s) => {
          if (s.id == step.targetA && !first_action_data.includes(s)) {
            first_action_data.push(s);
          }
        });
      } else {
        data.steps.find((s) => {
          if (
            s.targetA == null &&
            s.targetB == null &&
            !last_action_data.includes(s.id)
          ) {
            last_action_data.push(s.id);
            setlastactionmetadta(s);
          }
        });
        actions_data.push(step);
      }
    });
    first_action_data.forEach((firstAction) => {
      createGraph(firstAction, triggers_data, data.steps);
      setworkflow(workflow);
    });

    setworkflow(workflow);
    setfirstaction(first_action_data);
    settotalTriggerNode(triggers_data.length);
    settriggernodes(triggers_data);
    setactionnodes(actions_data);
    setsteps(data.steps);
    setlastaction(last_action_data);
    setShowLoader(false);
  }

  function createGraph(stepObject, sourceNodeList, stepList) {
    workflow.addNode(stepObject, sourceNodeList);
    var leftStep = null;
    var rightStep = null;
    if (stepObject.targetA != null) {
      leftStep = stepList.filter(
        (stepFromList) => stepFromList.id == stepObject.targetA
      );
      leftStep = leftStep[0];
    }

    if (stepObject.targetB != null) {
      rightStep = stepList.filter(
        (stepFromList) => stepFromList.id == stepObject.targetB
      );
      rightStep = rightStep[0];
    }

    var newSourceNodeList = [stepObject];
    processChild(leftStep, newSourceNodeList, stepList);
    processChild(rightStep, newSourceNodeList, stepList);
  }

  function processChild(childStep, sourceNodeList, stepList) {
    if (childStep != null) createGraph(childStep, sourceNodeList, stepList);
  }

  const editstep = (vari, cond, stp_id, metadata_id) => {

    setShowLoader(true);

    var workflow_id = wokflowData.workflowId;
    var variables = vari;
    var conditions = cond;
    var stp = steps;

    stp.map((step) => {
      if (step.id == stp_id) {
        step.variables = variables;
        step.conditions = conditions;
        step.metadata_id = metadata_id;
      }
    });

    edit_step(workflow_id, stp)
      .then((data) => {
        // showLoader(false);
        handlestepsResponse(data);
        forceUpdate();
      })
      .catch((e) => { });

    setshow(false);
  };
  //post_step(workflow_id,metadata_id,sources,target,variables,conditions,steps)
  const addstep = (vari, cond, modaltype, metaid, pth, source_id) => {
    setShowLoader(true);

    var temp = [];
    trigger_nodes.forEach((node) => {
      temp.push(node.id);
    });

    var source_arr = [];
    if (source_arr != null) {
      source_arr.push(source_id);
    }

    var workflow_id = wokflowData.workflowId;

    var metadata_id =
      modaltype.isAction && modaltype.category !== "App"
        ? modaltype.id
        : metaid;
    //sources

    var sources = modaltype.isAction
      ? action_nodes.length > 0
        ? modaltype.isconditional
          ? source_arr
          : last_action
        : temp
      : [];
    //target
    var target = modaltype.isAction
      ? null
      : action_nodes.length > 0
        ? first_action[0].id
        : null;
    var variables = vari;
    var conditions = cond;
    var path = pth;
    var stp = steps;
    post_step(
      workflow_id,
      metadata_id,
      sources,
      target,
      variables,
      conditions,
      path,
      stp
    )
      .then((data) => {
        // showLoader(false);
        handlestepsResponse(data);
        forceUpdate();
      })
      .catch((e) => { });

    setshow(false);
  };

  const modal_props = (
    show,
    modal_type,
    metadata_id,
    src,
    conditionalflag,
    path,
    trigger_data,
    category_data,
    editing_status,
    vari,
    cond,
    stp_id
  ) => {
    setshow(show);
    setconditionalflag(conditionalflag);
    setactionmodal(modal_type);
    setactionmetadataid(metadata_id);
    setmodalkey(uuidv1());
    setsourcenode(src);
    setpath(path);
    settriggerdata(trigger_data);
    setcategory(category_data);
    setisediting(editing_status);
    setvariables(vari);
    setconditions(cond);
    setstepid(stp_id);
    // forceUpdate()
  };

  const hideModal = () => {
    setshow(false);
  };

  const handle_loading = (state) => {
    setShowLoader(state);
  };

  const getchildren = (root) => {
    var children = workflow_graph.AdjList.get(root);

    if (children.length == 0) {
      return (
        <>
          <ul>
            <li>
              <Drop_Action_Node
                id={"drop_action" + root.id}
                name="Add an Action"
                modal_props={modal_props}
                conditional_node={false}
                add_step={addstep}
              ></Drop_Action_Node>
            </li>
          </ul>
          <Link
            start={root.id}
            end={"drop_action" + root.id}
            dashness={true}
          ></Link>
        </>
      );
    }
    return children.map((child) => {
      if (child.metadata.splitFlag == true) {
        //Conditional Node
        return (
          <ul>
            <li>
              <Conditional_node
                add_step={addstep}
                modal_props={modal_props}
                handle_loading={handle_loading}
                handlestepsResponse={handlestepsResponse}
                workflow_graph_data={workflow_graph.AdjList}
                action_data={child}
                get_children={getchildren}
              ></Conditional_node>
            </li>
          </ul>
        );
      } else if (child.metadata.splitFlag == false) {
        //Action Node
        return (
          <>
            <ul>
              <li>
                <Action_Node
                  name={child.metadata.name}
                  id={child.id}
                  action_data={child}
                  handlestepsResponse={handlestepsResponse}
                  handle_loading={handle_loading}
                  add_step={addstep}
                  modal_props={modal_props}
                ></Action_Node>
              </li>
            </ul>

            {getchildren(child)}
          </>
        );
      }
    });
  };

  return (
    <>
      {showLoader ? (
        <Content />
      ) : (
        <>
          <Xwrapper>
            {/* <TransformComponent> */}
            <div className="workflow">
              <ul>
                <li>
                  {workflow_graph.AdjList !== undefined ? (
                    <>
                      {[...workflow_graph.AdjList.keys()].map((node) => {
                        //To exclude the root node in graph
                        if (workflow_graph.getSources(node).length != 0) {
                          if (node.metadata.type == "StartEvent") {
                            return (
                              <Trigger_Node
                                id={node.id}
                                name={node.metadata.name}
                                initial_trigger={false}
                                trigger_data={node}
                                handlestepsResponse={handlestepsResponse}
                                modal_props={modal_props}
                                handle_loading={handle_loading}
                                totalTriggerNode={totalTriggerNode}
                              ></Trigger_Node>
                            );
                          }
                        }
                      })}

                      <Drop_Trigger_Node
                        id="drop_trigger"
                        name="Add a Trigger"
                        modal_props={modal_props}
                      ></Drop_Trigger_Node>
                      {action_nodes.length == 0 ? (
                        <Link
                          start="drop_trigger"
                          end="drop_action"
                          dashness={true}
                        />
                      ) : (
                        <Link
                          start="drop_trigger"
                          end={first_action[0].id}
                          dashness={true}
                        />
                      )}

                      {action_nodes.length == 0 ? (
                        <ul>
                          <li>
                            <Drop_Action_Node
                              id="drop_action"
                              name="Add an Action"
                              modal_props={modal_props}
                              conditional_node={false}
                              add_step={addstep}
                            ></Drop_Action_Node>
                          </li>
                        </ul>
                      ) : (
                        <>
                          {/* <Link start="drop_trigger" end={first_action[0].id} /> */}
                          {first_action[0].metadata.splitFlag == false ? (
                            <>
                              <ul>
                                <li>
                                  <Action_Node
                                    name={first_action[0].metadata.name}
                                    id={first_action[0].id}
                                    action_data={first_action[0]}
                                    handlestepsResponse={handlestepsResponse}
                                    handle_loading={handle_loading}
                                    add_step={addstep}
                                    modal_props={modal_props}
                                  ></Action_Node>
                                </li>
                              </ul>
                              {/* <Link start={first_action[0].id} end={"drop_action"+first_action[0].id} /> */}
                              {getchildren(first_action[0])}
                            </>
                          ) : (
                            <ul>
                              <li>
                                <Conditional_node
                                  add_step={addstep}
                                  modal_props={modal_props}
                                  handle_loading={handle_loading}
                                  handlestepsResponse={handlestepsResponse}
                                  workflow_graph_data={workflow_graph.AdjList}
                                  action_data={first_action[0]}
                                  get_children={getchildren}
                                ></Conditional_node>
                              </li>
                            </ul>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    ""
                  )}
                  <>
                    {action_nodes.length == 0 && trigger_nodes.length == 0 ? (
                      <Link
                        start="drop_trigger"
                        end="drop_action"
                        dashness={true}
                      />
                    ) : trigger_nodes.length > 0 && action_nodes.length == 0 ? (
                      trigger_nodes.map((trigger) => {
                        return (
                          <Link
                            start={trigger.id}
                            end="drop_action"
                            dashness={true}
                          />
                        );
                      })
                    ) : (
                      <>
                        {action_nodes.map((action) => {
                          return action.sources.map((source) => {
                            return (
                              <Link
                                start={source}
                                end={action.id}
                                dashness={false}
                                action={action}
                              />
                            );
                          });
                        })}
                      </>
                    )}
                  </>
                </li>
              </ul>
            </div>
            {/* <button onClick={() => zoomIn}>Inc</button>
              <button onClick={() => zoomOut}>Dec</button> */}
            {/* </TransformComponent> */}
          </Xwrapper>
          {show ? (
            action_modal ? (
              <Modal
                show={show}
                handleClose={hideModal}
                ModalType={
                  conditional_flag
                    ? {
                      conditions: conditions,
                      isAction: true,
                      isconditional: true,
                      id: metadata_id,
                      category: category,
                      isediting: isediting,
                      variables: variables,
                    }
                    : {
                      conditions: conditions,
                      isAction: true,
                      isconditional: false,
                      id: metadata_id,
                      category: category,
                      isediting: isediting,
                      variables: variables,
                    }
                }
                addstep={addstep}
                triggerdata={trigger_data}
                key={modalkey}
                source_id={sourcenode_id}
                path={conditional_path}
                editstep={editstep}
                step_id={step_id}
                permissionData={permissionData}
              />
            ) : (
              <Modal
                show={show}
                handleClose={hideModal}
                ModalType={{
                  conditions: conditions,
                  isAction: false,
                  id: isediting == true ? metadata_id : null,
                  category: category,
                  isediting: isediting,
                  variables: variables,
                }}
                addstep={addstep}
                key={modalkey}
                triggerdata={trigger_data}
                editstep={editstep}
                step_id={step_id}
                permissionData={permissionData}
              />
            )
          ) : (
            ""
          )}
        </>
      )}
    </>
  );
};

export default Playground;
